import { CarFront } from 'lucide-react';

// Deliberate spotlight frame — swaps to the client's real photo the moment one is supplied.
const VehicleImage = ({ src, alt, className = '', label = 'ALAS VELOCITY' }) => {
  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className={`h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105 ${className}`}
      />
    );
  }
  return (
    <div
      data-testid="vehicle-image-placeholder"
      role="img"
      aria-label={alt}
      className={`relative flex h-full w-full flex-col items-center justify-center overflow-hidden bg-gradient-to-b from-[#1c1c1c] to-[#0D0D0D] ${className}`}
    >
      <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse 70% 55% at 50% 42%, rgba(255,255,255,0.07), transparent 70%)' }} />
      <div className="absolute inset-x-8 top-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />
      <CarFront className="h-16 w-16 text-white/15 md:h-20 md:w-20" strokeWidth={0.75} />
      <span className="mt-5 text-[10px] font-medium uppercase tracking-[0.4em] text-gold/50">{label}</span>
      <span className="mt-2 text-[10px] uppercase tracking-[0.25em] text-white/25">Photography in production</span>
    </div>
  );
};

export default VehicleImage;
